<template>
  <div class="processed-by not-same mt-1 fw-bold">System Ended</div>
</template>

<script>
export default {}
</script>
